import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Container,
  Form,
  Input,
  FormGroup,
  Label,
  Button,
  Modal,
} from "reactstrap";
import BootstrapTable from 'react-bootstrap-table-next'
import DateTime from 'react-datetime'
import "react-datetime/css/react-datetime.css"
import Iframe from 'react-iframe'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import ReactSelect from 'components/Form/Select/Select'
import useForm from "lib/useForm"
import Loading from 'lib/loading'
import rotas from 'services/rotas'
import rest from 'lib/rest'
import {homepage} from '../../../../package.json';

const formSwal = withReactContent(Swal)

const inicialResumo = {
  semDesconto:  0,
  ComDesconto:  0,
  desconto:     0,
  porcentagem:  0
}

const filtroTotalizado  = [
  {id:'categoria', title:'Categoria'},
  {id:'vendedor', title:'Vendedor'},
  {id:'tabloid', title:'Tabloid'}
]

const Desconto = () => {

  const [form, onChange, setForm, onChangeSelect, onChangeDate] = useForm([])

  const [loading, setLoading]             = useState(true)
  const [loadingTabela, setLoadingTabela] = useState(false)
  const [lojas, setLojas]                 = useState([])
  const [categorias, setCategorias]       = useState([])
  const [fornecedores, setFornecedores]   = useState([])
  const [listaDesconto, setListaDesconto] = useState([])
  const [resumo, setResumo]               = useState(inicialResumo)
  const [divResumo, setdivResumo]         = useState('d-none')
  const [pathPDF, setPathPDF]             = useState('')
  const [modalPrint, setModalPrint]       = useState(false)
  const [selectFiltro, setSelectFiltro] = useState({id:'categoria', title:'Categoria'})

  const colunas = [
    {
      dataField: 'nome',
      text: selectFiltro.title,
      headerStyle: { cursor: 'text' }
    },
    {
      dataField: 'itemvend_prtabela',
      text: 'Sem Desconto',
      headerStyle: { cursor: 'text' },
      formatter: (cellContent, row) => {return (parseFloat(cellContent).toLocaleString('pt-br', { style: 'currency', currency: 'BRL',minimumFractionDigits: 1, maximumFractionDigits: 2 }))}
    },
    {
      dataField: 'itemvend_prvenda',
      text: 'Com Desconto',
      headerStyle: { cursor: 'text' },
      // sort: true,
      formatter: (cellContent, row) => {return (parseFloat(cellContent).toLocaleString('pt-br', { style: 'currency', currency: 'BRL',minimumFractionDigits: 1, maximumFractionDigits: 2 }))}
    },
    {
      dataField: 'desconto_valor',
      text: 'Desconto',
      headerStyle: { cursor: 'text' },
      // sort: true,
      formatter: (cellContent, row) => {return (parseFloat(cellContent).toLocaleString('pt-br', { style: 'currency', currency: 'BRL',minimumFractionDigits: 1, maximumFractionDigits: 2 }))}
    },
    {
      dataField: 'desconto_percent',
      text: 'Porcentagem',
      headerStyle: { cursor: 'text' },
      formatter: (cellContent, row) => { return(cellContent+" %")}
    }
  ]

  const listaLojas = () => {
    let lista = [{id: 0, title: 'TODAS'}]
    const url = rotas.lojas
    try{
      const retorno = rest.get(url)
      retorno.then(ret => {
        if (ret.success && ret.success == 'S' && ret.lista != ''){
          for (let i = 0; i < ret.lista.length; i++) {
            lista[i+1] = {"id":ret.lista[i].filial_id, "title":ret.lista[i].fantasia}
          }
          setLojas(lista)
        }
      })
    }catch(err){
      console.log(err)
    }
  }

  const listarCategorias = () => {
    const url     = rotas.categoriaSelect;
    const retorno = rest.get(url);
    retorno.then(ret => {
      if (ret.success && ret.success == 'S' && ret.lista != '' && ret.lista != null) {
        let lista = [];
        ret.lista.map(lst => {
          lista.push({ id: lst.categoria_id, title: lst.categoria });
        });
        setCategorias(lista);
      }
      setLoading(false)
    })
  }

  const listarFornecedores = () => {
    const url     = rotas.fornecedorProduto
    const retorno = rest.get(url);
    retorno.then(ret => {
      if (ret.success && ret.success == 'S' && ret.lista != '' && ret.lista != null) {
      let lista = [];
        ret.lista.map(lst => {
          lista.push({ id: lst.fornecedor_id, title: lst.fornecedor });
        });
        setFornecedores(lista);
      }
      setLoading(false)
    })
  }

  const imprimirPDF = () => {
    if (listaDesconto.length > 0) {
      
      let dados = {
        rede:     sessionStorage.getItem('rede'),
        usuario:  sessionStorage.getItem('usuario'),
        dataI:    form['inicio'],
        dataF:    form['final'],
        lista:    listaDesconto,
        total:    resumo,
        filtro:   selectFiltro.id
      }
  
      try{
        const url     = rotas.desconto+"pdf/"
        const retorno = rest.post(url, dados);
  
        retorno.then(ret => {
          if (ret.success && ret.success == 'S' && ret.path != '' && ret.path != null) {
            let caminho = url.split('/');
            let caminhoPDF = '';
  
            for(let x = 0 ; x < caminho.length -1 ; x++){
              if(caminhoPDF === ''){
                caminhoPDF = caminho[x]; 
              }else{
                caminhoPDF = caminhoPDF + '/' + caminho[x];
              }
            }
            setPathPDF( homepage + '/' + caminhoPDF + ret.path);
            setModalPrint(true);
  
          } else {
            console.log(ret);
            // Swal.fire('Erro', 'Erro na geração da impresão', 'error');
          }
        })
      }catch(err){
        console.log(err)
      }
    }
  }

  const pesquisaSubmit = (e) => {
    e.preventDefault()

    setdivResumo('d-none')
    setLoadingTabela(true)

    let dados = {
      form :  form,
      filtro: selectFiltro.id
    }

    const url     = rotas.desconto
    const retorno = rest.post(url, dados)

    try {
      retorno.then(ret => {
        console.log(ret.lista);
        if (ret.success && ret.success == 'S'){
          setListaDesconto(ret.lista)
          setResumo(ret.totais)
          setdivResumo('')
        }else{
          setListaDesconto([])
          setResumo([])
          if (ret.aviso) {
            formSwal.fire('Erro!', ret.msg, 'error')
          }
        }
        setLoadingTabela(false)
      })
    } catch (error) {
      console.log(error);
      setListaDesconto([])
      setResumo([])
      setLoadingTabela(false)
    }
  }

  const onChangeFiltro = (select) => {
    // console.log(select);

    setSelectFiltro(select)
    setdivResumo('d-none')
    setLoadingTabela(true)

    let dados = {
      form :  form,
      filtro: select.id
    }

    const url     = rotas.desconto
    const retorno = rest.post(url, dados)

    try {
      retorno.then(ret => {
        console.log(ret.lista);
        if (ret.success && ret.success == 'S'){
          setListaDesconto(ret.lista)
          setResumo(ret.totais)
          setdivResumo('')
        }else{
          setListaDesconto([])
          setResumo([])
          if (ret.aviso) {
            formSwal.fire('Erro!', ret.msg, 'error')
          }
        }
        setLoadingTabela(false)
      })
    } catch (error) {
      console.log(error);
      setListaDesconto([])
      setResumo([])
      setLoadingTabela(false)
    }
  }

  useEffect(() => {
    listaLojas()
    listarCategorias()
    listarFornecedores()
  }, [])

  if (loading) {
    return ( <Loading tipo='paginas' /> )
  } else {
    return (
      <div className="content" key="585">
        <Container>
          <Row>
            <Col md="12" className="p-0">
              <Card>
                <CardHeader>
                  <CardTitle>ESTATÍSTICA DE DESCONTO</CardTitle>
                </CardHeader>
                <CardBody>

                  <div className="border p-3">
                    <Form onSubmit={pesquisaSubmit}>
                      <Container>
                        <Row>

                          <Col md='8'>
                            <FormGroup className="mb-0">
                              <ReactSelect
                                isMulti
                                name          = "lojas"
                                placeholder   = "Selecione a Loja"
                                options       = {lojas}
                                defaultValue  = {form.filialSelect}
                                onChange      = {onChangeSelect('filialSelect')}
                                onClick       = {form.filialSelect ? form.filial = form.filialSelect.id : ''}
                              ></ReactSelect>
                            </FormGroup>
                          </Col>

                          <Col md='2'>
                            <FormGroup className="mb-0">
                              <DateTime
                                id            = "dataInicial"
                                name          = "dataInicial"
                                inputProps    = {{ placeholder: "Período Inicial" }}
                                closeOnSelect = {true}
                                dateFormat    = "DD/MM/YYYY"
                                timeFormat    = {false}
                                value         = {form.inicio}
                                onChange      = {onChangeDate('inicio')}
                              >
                              </DateTime>
                            </FormGroup>
                          </Col>

                          <Col md='2'>
                            <FormGroup className="mb-0">
                              <DateTime
                                id            = "dataFinal"
                                name          = "dataFinal"
                                inputProps    = {{ placeholder: "Período Final" }}
                                closeOnSelect = {true}
                                timeFormat    = {false}
                                dateFormat    = "DD/MM/YYYY"
                                value         = {form.final}
                                onChange      = {onChangeDate('final')}
                              >
                              </DateTime>
                            </FormGroup>
                          </Col>

                          <Col md="4">
                            <FormGroup className="mb-0 mt-3">
                              <ReactSelect
                                isMulti
                                id              = 'slecFornecedor'
                                name            = "selectFornecedor"
                                placeholder     = "Selecione o Fornecedor"
                                options         = {fornecedores}
                                onChange        = {onChangeSelect('fornecedorSelect')}
                                onClick         = {form.fornecedorSelect ? form.fornecedor_id = form.fornecedorSelect.id : ''}
                              />
                            </FormGroup>
                          </Col>

                          <Col md="4">
                            <FormGroup className="mb-0 mt-3">
                              <ReactSelect
                                isMulti
                                id              = "selectCategoria"
                                name            = "selectCategoria"
                                classNamePrefix = "react-select"
                                placeholder     = "Selecione a Categoria"
                                options         = {categorias}
                                onChange        = {onChangeSelect('categoriaSelect')}
                                onClick         = {form.categoriaSelect ? form.categoria_id = form.categoriaSelect.id : ''}
                              />
                            </FormGroup>
                          </Col>

                          <Col md='2' style={{ display: "flex", justifyContent: "center", }}>
                            <FormGroup className="mb-0">
                              <Button
                                color   = "warning"
                                onClick = {imprimirPDF}
                              >
                                IMPRIMIR
                                <i className="nc-icon nc-single-copy-04 pl-2" style={{ fontSize: '18px' }} />
                              </Button>
                            </FormGroup>
                          </Col>
                          
                          <Col md="2">
                            <FormGroup className="mb-0" style={{ display: "flex", justifyContent: "right", }}>
                              <Button 
                              color = "success"
                              type  = 'submit'
                              >
                                Gerar
                                <i className="nc-icon nc-zoom-split pl-2" style={{ fontSize: '18px' }} />
                              </Button>
                            </FormGroup>
                          </Col>

                        </Row>
                      </Container>
                    </Form>

                    <Container className="mt-3">
                      <Row style={{ display: "flex", justifyContent: "center", }}>
                        <Col md='4'>
                          <FormGroup className="mb-3">
                            <Label for="filtroTotalizado">Selecione o agrupamento</Label>
                            <ReactSelect
                              name          = "filtroTotalizado"
                              placeholder   = "Selecione o filtro"
                              options       = {filtroTotalizado}
                              defaultValue  = {selectFiltro}
                              onChange      = {onChangeFiltro}
                              // onClick       = {}
                            ></ReactSelect>
                          </FormGroup>
                        </Col>

                      </Row>

                      {
                        loadingTabela ?  <Loading tipo='componente' /> 
                        :
                          <BootstrapTable
                            striped
                            keyField          = 'curva_classificacao'
                            data              = {listaDesconto}
                            columns           = {colunas}
                            noDataIndication  = "Nenhum registro encontrado"
                            // pagination        = {paginationFactory({
                            //                       sizePerPage: 20,
                            //                       hideSizePerPage: true,
                            //                       hidePageListOnlyOnePage: true,
                            //                       showTotal: false,
                            //                     })}
                            rowStyle          = {{ cursor: "pointer" }}                          
                          />
                      }

                      <Row className={divResumo}>
                        <Col md="3">
                          <div className="card-2 pl-3 ml-0">
                            <Col md="12">
                              <span className="tag-card">
                                  <span className="form-check-sign bg-success" />Sem Desconto
                              </span>
                            </Col>
                            <Row>
                              <Col>
                              <FormGroup className="text-center">
                                <Input
                                  disabled
                                  name      = "semDesconto"
                                  type      = "text"
                                  className = "text-center font-weight-bold text-info"
                                  value     = {parseFloat(resumo['semDesconto']).toLocaleString('pt-br', { style: 'currency', currency: 'BRL',minimumFractionDigits: 1, maximumFractionDigits: 2 })}
                                />
                              </FormGroup>
                              </Col>
                            </Row>
                            
                          </div>
                        </Col>

                        <Col md="3">
                          <div className="card-2 pl-3 ml-0">
                            <Col md="12">
                              <span className="tag-card">
                                  <span className="form-check-sign bg-warning" />Com Desconto
                              </span>
                            </Col>
                            <Row>
                              <Col>
                              <FormGroup className="text-center">
                                <Input
                                  disabled
                                  name      = "comDesconto"
                                  type      = "text"
                                  className = "text-center font-weight-bold text-success"
                                  value     = {parseFloat(resumo['comDesconto']).toLocaleString('pt-br', { style: 'currency', currency: 'BRL',minimumFractionDigits: 1, maximumFractionDigits: 2 })}
                                />
                              </FormGroup>
                              </Col>
                            </Row>
                            
                          </div>
                        </Col>

                        <Col md="3">
                          <div className="card-2 pl-3 ml-0">
                            <Col md="12">
                              <span className="tag-card">
                                <span className="form-check-sign bg-danger" />Desconto
                              </span>
                            </Col>
                            <Row>
                              <Col>
                              <FormGroup className="text-center">
                                <Input
                                  disabled
                                  name      = "desconto"
                                  type      = "text"
                                  className = "text-center font-weight-bold text-success"
                                  value     = {parseFloat(resumo['desconto']).toLocaleString('pt-br', { style: 'currency', currency: 'BRL',minimumFractionDigits: 1, maximumFractionDigits: 2 })}
                                />
                              </FormGroup>
                              </Col>
                            </Row>
                            
                          </div>
                        </Col>

                        <Col md="3">
                          <div className="card-2 pl-3 ml-0">
                            <Col md="12">
                              <span className="tag-card">
                                  <span className="form-check-sign bg-success" />Porcentagem
                              </span>
                            </Col>
                            <Row>
                              <Col>
                              <FormGroup className="text-center">
                                <Input
                                  disabled
                                  name      = "porsentagem"
                                  type      = "text"
                                  className = "text-center font-weight-bold text-info"
                                  value     = {resumo['porcentagem']+" %"}
                                />
                              </FormGroup>
                              </Col>
                            </Row>
                            
                          </div>
                        </Col>
                      </Row>

                    </Container>

                  </div>

                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <Modal
          key     = 'modrelat'
          size    = 'xl'
          height  = "700px"
          isOpen  = {modalPrint}
        >
          <Iframe
            allowFullScreen
            id        = "myId"
            name      = "myId"
            className = "myClassname"
            width     = "100%"
            height    = "580px"
            display   = "initial"
            position  = "relative"
            url       = {pathPDF}
            >
          </Iframe>
          <Row>
            <Col className="text-center p-3">
              <Button
                type      = "button"
                className = "mb-0 mt-0"
                color     = "success"
                size      = "md"
                onClick   = {()=>{window.open(pathPDF)}}
              >Baixar
                </Button>
              <Button
                type      = "button"
                className = "mb-0 mt-0"
                color     = "default"
                size      = "md"
                onClick   = {()=>{setModalPrint(false)}}>Fechar</Button>
            </Col>
          </Row>
        </Modal>
      </div>
    )
  }

}

export default Desconto
